<template>
  <div v-if="getMusterOption()">
    <SaveProductConfigurationModal v-if="sampleConfigValid()" :buttonLabel="'txtSaveOrderAndProceedToBasket'|translate"
                                   name="save-sample-productConf" @saveConfiguration="saveSampleAndAddToBasket($event)">
      <a @click="$modal.show('save-sample-productConf')" :disabled="!configuratorService.isConfigurationComplete()"
         class="btn btn--link w-100 text-shade-darker font-weight-light text-decoration-none flex-column">
        <div>{{'txtOrderSamples' | translate}}</div>
        <span class="text-xsmall">{{'txtVersandMuster' | translate}} {{ musterVersandtermin }}</span>
      </a>
    </SaveProductConfigurationModal>
    <div v-else-if="samplesAllowed" class="d-flex p-2 w-100 text-small line-height-12">
      <svg xmlns="http://www.w3.org/2000/svg" class="mr-2 svg-icon flex-child-fix position-relative t-1px" viewBox="0 0 36 36">
        <circle cx="18" cy="18" r="18" fill="#707171"/>
        <path
            d="M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z"
            fill="#fff"/>
      </svg>
      {{'txtSampleRestrictionInfo' | translate}}
    </div>
  </div>
</template>

<script>
import SaveProductConfigurationModal from "components/sidebarbuttons/SaveProductConfigurationModal";

export default {
  name: 'OrderSampleButton',
  components: {SaveProductConfigurationModal},
  inject: ['configuratorService'],
  methods: {
    getMusterOption() {
      return this.configuratorService.byConfigoptionType('Muster')
    },
    sampleConfigValid() {
      const option = this.getMusterOption();
      return this.configuratorService.isConfigurationComplete() &&
          !this.configuratorService.isAuspraegungExcluded(option, this.getTrueAuspraegungId())
    },
    getTrueAuspraegungId() {
      const option = this.getMusterOption();
      return option.customValues.MusterTrueId;
    },
    saveSampleAndAddToBasket(name) {
      if (this.configInvalid) {
        return;
      }
      this.configuratorService.saveConfiguration(name).then(() => {
        this.configuratorService.setSelectedAuspraegung(
            this.getMusterOption(), this.getTrueAuspraegungId(), true)
        this.configuratorService.addToBasket().then(() => this.configuratorService.navigateToBasket())
      });
    },
  },
  computed: {
    musterVersandtermin() {
      return this.getMusterOption().customValues.MusterDeliveryDates.produktionsdauerPriceBoxMuster
    },
    samplesAllowed() {
      return this.configuratorService.hasConfigoptionType('Muster')
    },
  },


}
</script>
